export const ROUTES = {
  IIRSA_PROJECT_DETAIL: '/actions/:id/show',
};

export default ROUTES;
